export default __webpack_public_path__ + "media/images/logo_transparent_black-b3d12819920bb125ed16bfd1c7524093.svg";